<template>
  <div class="stripes" />
</template>

<style lang="css" scoped>
.stripes {
  --from-color: var(--ui-bg);
  --to-color: var(--color-primary-300);

  background: repeating-linear-gradient(
    45deg,
    var(--from-color),
    var(--from-color) 10px,
    var(--to-color) 10px,
    var(--to-color) 20px
  );
}
.dark .stripes {
  --from-color: var(--color-primary-600);
  --to-color: var(--ui-bg);
}
</style>
